import React from 'react';
import classNames from 'classnames';

import styles from './SuperBatchModulesTableHeader.module.scss';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function SuperBatchModulesTableHeader() {
  return (
    <TableHead className={styles.root}>
      <TableRow>
        <TableCell
          className={classNames(styles.heading, styles.dragdrop)}
        ></TableCell>
        <TableCell className={classNames(styles.heading, styles.order)}>
          Order
        </TableCell>
        <TableCell className={classNames(styles.heading, styles.moduleDetails)}>
          Module Details
        </TableCell>
        <TableCell
          className={classNames(styles.heading, styles.action)}
        ></TableCell>
        <TableCell
          className={classNames(styles.heading, styles.status)}
        ></TableCell>
        <TableCell
          className={classNames(styles.heading, styles.status)}
        ></TableCell>
        <TableCell
          className={classNames(styles.heading, styles.action)}
        ></TableCell>
      </TableRow>
    </TableHead>
  );
}

export default SuperBatchModulesTableHeader;
